import theme from '@/config/theme';
import styled from 'vue-styled-components';

export const InputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;

  label {
    font-size: 0.9rem;
  }

  .provider {
    width: 100%;
    display: flex;
  }
`;

export const Title = styled.h6`
  color: ${theme.colors.primaryBlue};;
  font-weight: ${theme.font.regular};
`;

export const InputGroup = styled.div`
  display: flex;
  width: 100%;
`;

export const InputGroupPrepend = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 48px;

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${theme.colors.gray4};
    border-radius: ${theme.border.radius.xsmall};
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: #e9ecef;
    padding: 0.2rem 0.75rem;
    height: 100%;
    border-right: none;

    svg {
      width: 35px;
      height: 35px;
    }
  }
`;

export const WrapperButton = styled('div')`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-top: ${theme.spacings.xxxlarge};
`;

export const Message = styled('p')`
  color: ${theme.colors.gray6};
  font-size: ${theme.font.sizes.p1};
  line-height: ${theme.font.lineHeights.p1};
  margin-top: ${theme.spacings.xxlarge};

  span {
    align-items: center;
    color: ${theme.colors.gray6};
    display: flex;
    font-weight: ${theme.font.bold};

    svg {
      margin-right: ${theme.spacings.xsmall};
    }
  }
`;

export const WrapperInput = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings.xxxlarge};
  margin-top: ${theme.spacings.xxxlarge};

  .validation-error {
    color: ${theme.colors.supportError};
    font-size: ${theme.font.sizes.p3};
    margin-top: 5px;
    text-align: right;
  }
`;

export const Container = styled.div`
  margin: auto;
  min-width: 240px;
  max-width: 974px;
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 1.5rem;
  padding: 1rem 2rem;
  border-radius: ${theme.border.radius.small};
  box-shadow: ${theme.shadow.lv1};
  background-color: #fff;

  .contentButtonBack {
    width: 100%;
    display: grid;
    justify-content: start;

    button {
      width: 35px;
    }
  }

  .stepsContent,
  .providerContainer,
  button {
    width: 100%;
  }

  .loadingContainer {
    position: relative;
    width: 100%;
    height: 50px;
  }
`;

export const Input = styled.input`
  background: ${theme.colors.gray1};
  border: 1px solid ${theme.colors.gray4};
  border-radius: ${theme.border.radius.xsmall};
  color: ${theme.colors.black};
  font-size: ${theme.font.sizes.p2};
  font-weight: ${theme.font.regular};
  height: 48px;
  line-height: ${theme.font.lineHeights.p2};
  padding: ${theme.spacings.xsmall} ${theme.spacings.medium};
  width: 100%;

  &.isIcon {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &::placeholder {
    color: ${theme.colors.gray4};
    font-weight: ${theme.font.regular};
  }

  &:hover,
  &:focus {
    background: ${theme.colors.white};
    border-color: ${theme.colors.primary};
  }

  &:focus,
  &.active {
    background: ${theme.colors.white};
    font-weight: ${theme.font.regular};
  }

  & ~ div {
    display: none;
  }

  &:hover ~ div {
    display: block;
    position: absolute;
    right: 0;
    top: calc(100% + 10px);
    z-index: ${theme.layers.base};
  }

  &:focus ~ a,
  &.active ~ a {
    color: ${theme.colors.gray5} !important;
  }

  &:focus::placeholder {
    color: ${theme.colors.black};
  }

  &:focus ~ label:first-of-type {
    align-items: center;
    color: ${theme.colors.primary};
    margin-top: 0;
    opacity: 1;
    top: -24px;
  }

  &.error {
    border-color: ${theme.colors.supportError};

    &:focus ~ label:first-of-type {
      color: ${theme.colors.supportError};
    }
  }

  &.disabled {
    color: gray;
    border-color: gray;
    background-color: ${theme.colors.gray3};
    pointer-events: none;
  }
`;
